import * as React from 'react';

import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import type { OmitStylesHTMLAttributes } from '../../types';

const sheetHeaderVariants = cva('rocco-sheet-header flex flex-col space-y-2', {
    variants: {
        variant: {
            default:
                'border-b border-gray-900/30 px-6 pb-3 pt-6 md:pb-4.5 md:pt-7',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const SheetHeader = ({
    variant,
    ...props
}: OmitStylesHTMLAttributes<HTMLDivElement> &
    VariantProps<typeof sheetHeaderVariants>) => (
    <div className={sheetHeaderVariants({ variant })} {...props} />
);

SheetHeader.displayName = 'SheetHeader';
